import { signal } from '@preact/signals';
import { getItem, setItem } from '../lib/storage';

/**
 * Controls visibility of the WelcomeSheet. Auto-opens on first visit (no
 * stored `watcherName`) and can be re-opened externally from the "Watching
 * as …" row in the drawer so the watcher can change the name that shows up
 * in the traveller's mobile companion list.
 */
export const welcomeSheetOpen = signal<boolean>(false);

/**
 * Watcher's currently-stored display name (the one the traveller sees in
 * their companion list). Seeded from localStorage on boot, kept in sync by
 * `setWatcherName` so the drawer's "Watching as …" row updates immediately
 * after a save without re-reading storage.
 *
 * `null` = never asked, `''` = explicitly skipped. Both are valid states.
 */
export const watcherName = signal<string | null>(getItem('watcherName'));

export function setWatcherName(name: string): void {
  setItem('watcherName', name);
  watcherName.value = name;
}

export function openWelcomeSheet(): void {
  welcomeSheetOpen.value = true;
}

export function closeWelcomeSheet(): void {
  welcomeSheetOpen.value = false;
}
